// File: src/pages/seller/AddProduct/sections/FAQs.jsx
import React from "react";
import { useFormContext } from "react-hook-form";
import { CRow, CCol, CFormInput, CButton, CSpinner } from "@coreui/react";
import { FaTrash } from "react-icons/fa";
import CIcon from "@coreui/icons-react";
import { cilLightbulb } from "@coreui/icons";

const FAQs = ({ onGenerateAi, aiLoading }) => {
  const { watch, setValue } = useFormContext();
  const faqs = watch("faqs") || [];

  const addFaq = () =>
    setValue("faqs", [...faqs, { question: "", answer: "" }]);
  const removeFaq = (i) =>
    setValue(
      "faqs",
      faqs.filter((_, idx) => idx !== i)
    );
  const updateFaq = (i, key, val) => {
    const copy = [...faqs];
    copy[i] = { ...copy[i], [key]: val };
    setValue("faqs", copy, { shouldValidate: true });
  };

  return (
    <div
      style={{
        border: "1px solid #dcdcdc",
        borderRadius: "8px",
        padding: "1.5rem",
        position: "relative",
        marginBottom: "1.5rem",
      }}
    >
      {/* Section Title */}
      <span
        style={{
          position: "absolute",
          top: "-0.8rem",
          left: "1rem",
          backgroundColor: "white",
          padding: "0 0.5rem",
          fontWeight: "600",
          color: "#333",
          fontSize: "1rem",
        }}
      >
        Frequently Asked Questions
      </span>

      <div className="mb-3 d-flex gap-2">
        <CButton color="secondary" variant="outline" onClick={addFaq}>
          + Add New
        </CButton>
        <CButton
          color="secondary"
          variant="outline"
          size="sm"
          disabled={aiLoading}
          onClick={onGenerateAi}
        >
          {aiLoading ? (
            <CSpinner size="sm" />
          ) : (
            <>
              <CIcon icon={cilLightbulb} className="me-1" />
              Generate with AI
            </>
          )}
        </CButton>
      </div>

      {faqs.map((faq, index) => (
        <CRow className="mb-3" key={index}>
          <CCol md={5}>
            <CFormInput
              placeholder="Enter question"
              value={faq.question}
              onChange={(e) => updateFaq(index, "question", e.target.value)}
            />
          </CCol>
          <CCol md={5}>
            <CFormInput
              placeholder="Enter answer"
              value={faq.answer}
              onChange={(e) => updateFaq(index, "answer", e.target.value)}
            />
          </CCol>
          <CCol md={2} className="d-flex align-items-center">
            <CButton
              color="danger"
              variant="outline"
              size="sm"
              onClick={() => removeFaq(index)}
              title="Remove FAQ"
            >
              <FaTrash />
            </CButton>
          </CCol>
        </CRow>
      ))}

      {faqs.length === 0 && <p className="text-muted">No FAQs added yet.</p>}
    </div>
  );
};

export default React.memo(FAQs);
